export default __webpack_public_path__ + "static/3-3537b4f17341068c5f47db2a9407a338.jpg";